/** @jsxImportSource @emotion/react */
import AvatarMui from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';

import { fonts } from '../../style/fonts';
import { User } from '../../models/User';
import { CSSObject } from '@emotion/react';
import { breakpoints } from '../../style/breakpoints';

const muiAvatarCss: CSSObject = {
  ...fonts.largeLabel,
  width: 20,
  height: 20,

  [breakpoints.small]: {
    width: 30,
    height: 30,
  },
};

function acronym({ name }: { name: string }) {
  const a = name.replace('dr.', '');
  const split = a.split(' ');
  const final = `${split[0]?.charAt(0) ?? ''}${split[1]?.charAt(0) ?? ''}`;
  return final;
}

export default function Avatar({ user }: { user: User }) {
  return (
    <Tooltip title={user.name}>
      <AvatarMui sx={muiAvatarCss}>{acronym(user).toUpperCase()}</AvatarMui>
    </Tooltip>
  );
}
